// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@nrwl/web/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".phoneVerification_phoneVerification__2RVSS {\n  display: flex;\n}\n.phoneVerification_phoneVerification__2RVSS input {\n  margin-right: 1rem;\n}", ""]);
// Exports
exports.locals = {
	"phoneVerification": "phoneVerification_phoneVerification__2RVSS"
};
module.exports = exports;
